module.exports = __webpack_public_path__ + "static/media/hunny-logo-text.f326f456.png";